const KEY = "machineId"

function makeUuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID()

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === "x" ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

function readCookie(name) {
  const m = document.cookie.match(
    new RegExp(`(^|; )${name}=([^;]*)`)
  )
  return m ? decodeURIComponent(m[2]) : null
}

function writeCookie(name, value) {
  const twoYears = 60 * 60 * 24 * 730
  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${twoYears}; Path=/; SameSite=Lax`
}

/**
 * Stable-ish ID for this browser profile. Stored in BOTH localStorage and a
 * cookie so clearing one alone doesn't rotate it and force a re-login.
 *
 * NOTE: logoutUser() must NOT remove this key — rotating it on every logout
 * would defeat the whole point of device tracking.
 */
export function getMachineId() {
  let id = null

  try {
    id = localStorage.getItem(KEY)
  } catch {
    /* private mode */
  }

  if (!id) id = readCookie(KEY)
  if (!id) id = makeUuid()

  try {
    localStorage.setItem(KEY, id)
  } catch {
    /* ignore */
  }

  writeCookie(KEY, id)
  return id
}